import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY_FORM = { name: "", email: "", message: "" };

const inputClass =
  "w-full rounded-xl border border-white/10 bg-[#0B0C10]/60 px-5 py-4 text-sm text-[#F4F6FB] placeholder:text-[#F4F6FB]/30 outline-none backdrop-blur-xl transition-colors duration-300 focus:border-[#8B5CF6]/60";

export const ContactForm = ({ onSent }) => {
  const [form, setForm] = useState(EMPTY_FORM);
  const [sending, setSending] = useState(false);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await fetch(`${API}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("send failed");
      toast.success("Transmission received. A confirmation is on its way to your inbox.");
      setForm(EMPTY_FORM);
      onSent();
    } catch {
      toast.error("Transmission failed. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-8 space-y-4">
      <input
        data-testid="contact-name-input"
        type="text"
        required
        maxLength={100}
        placeholder="Your name"
        value={form.name}
        onChange={update("name")}
        className={inputClass}
      />
      <input
        data-testid="contact-email-input"
        type="email"
        required
        placeholder="Your email"
        value={form.email}
        onChange={update("email")}
        className={inputClass}
      />
      <textarea
        data-testid="contact-message-input"
        required
        maxLength={2000}
        rows={4}
        placeholder="What are we building?"
        value={form.message}
        onChange={update("message")}
        className={`${inputClass} resize-none`}
      />
      <button
        data-testid="contact-submit-button"
        type="submit"
        disabled={sending}
        className="group relative w-full overflow-hidden rounded-full bg-gradient-to-r from-[#8B5CF6] to-[#06B6D4] p-px disabled:opacity-60"
      >
        <span className="flex items-center justify-center gap-3 rounded-full bg-[#0B0C10]/85 px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-[#F4F6FB] transition-colors duration-300 group-hover:bg-transparent group-hover:text-[#0B0C10]">
          {sending ? "Transmitting…" : "Send Transmission"}
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
        </span>
      </button>
    </form>
  );
};

export default ContactForm;
